import store from '@js/store'

export default [
    {
        path: 'categories',
        name: 'appUtilityCategory',
        redirect: { name: 'appUtilityCategoryList' },
        meta: { 
            title: 'utility.category.categories', 
            icon: 'fas fa-list',
            hideChildren: true,
            isNotNav: false,
            permissions: ['access-property']
        },
        beforeEnter: ((to, from, next) => {
            if( 0 && !store.getters['config/configs'].system.category) {
                next({ name: 'appDashboard'})
            } else {
                next()
            }
        }),
        component: {
            template: '<router-view></router-view>'
        },
        children: [
            {
                path: '',
                name: 'appUtilityCategoryList',
                meta: { 
                    trans: 'global.list',
                    title: 'utility.category.categories',
                },
                component: () => import('@views/app/utility/category/index' /* webpackChunkName: "js/app/utility/category/index" */),
            },
            {
                path: 'add',
                name: 'appUtilityCategoryAdd',
                meta: { 
                    trans: 'global.add',
                    title: 'utility.category.category',
                },
                component: () => import('@views/app/utility/category/add' /* webpackChunkName: "js/app/utility/category/add" */),
            },
            {
                path: ':uuid/edit',
                name: 'appUtilityCategoryEdit',
                meta: { 
                    trans: 'global.edit',
                    title: 'utility.category.category',
                },
                component: () => import('@views/app/utility/category/edit' /* webpackChunkName: "js/app/utility/category/edit" */),
            },
            {
                path: ':uuid/edit_gallery',
                name: 'appUtilityCategoryEditGallery',
                meta: { 
                    trans: 'utility.category.props.icon',
                    title: 'utility.category.category',
                },
                component: () => import('@views/app/utility/category/edit_gallery' /* webpackChunkName: "js/app/utility/category/edit_gallery" */),
            }            
        ]
    },
]